<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <base-card
          title="Settings"
          icon="settings"
        >
          <v-flex xs12 md6>
            <p>RNA Type:</p>
            <v-overflow-btn
              v-model="rnaType"
              @change="saveRNAType"
              :items="rnaTypes"
              item-value="value"
            >
<!--              <v-btn-->
<!--                v-for="rnaType in rnaTypes"-->
<!--                :value="rnaType.value"-->
<!--                :key="rnaType.value"-->
<!--                flat-->
<!--              >-->
<!--                {{rnaType.text}}-->
<!--              </v-btn>-->
            </v-overflow-btn>
          </v-flex>
          <v-flex xs12 md6>
            <p>Data Type:</p>
            <v-radio-group
              v-model="dataType"
              @change="saveDataType"
              row
            >
              <v-radio
                v-for="dataType in dataTypes"
                :label="dataType.text"
                :value="dataType.value"
                :key="dataType.value"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-layout row wrap>
                <v-flex xs12 sm6 md-3>
                  <v-select
                    :items="geneSets"
                    v-model="selectedGeneSet"
                    @change="select"
                    label="Select a gene set"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-textarea
                    v-model.trim="geneList"
                    name="gene-list"
                    :label="searchGenesPlaceholder"
                    box
                    hint="Separated by comma"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-btn
                    :disabled="!valid"
                    :loading="searchBtnLoading"
                    @click="submit"
                  >
                    Search
                  </v-btn>
                  <v-btn @click="reset">
                    Reset
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </base-card>
      </v-flex>
      <v-flex xs12>
        <base-card
          title="Meta Table"
          icon="apps"
        >
          <v-flex xs12>
            <Heatmap
              :data-type="dataType"
              :rna-type="rnaType"
              @init="initHandler"
              @stateSaveParams="stateSaveParamsHandler"
              @search="searchHandler"
              @xhr="xhrHandler"
              ref="heatmap"
            ></Heatmap>
          </v-flex>
        </base-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Heatmap from '@/components/Heatmap.vue';
import { GENE_LISTS } from '@/assets/data/MetaTable';
import { setSession, RNA_TYPE_KEY, DATA_TYPE_KEY } from '@/assets/js/cache';
import { RNA_TYPES, RNA_VALUES } from '@/assets/data/RNATypes';
import { DATA_TYPES, DATA_VALUES } from '@/assets/data/DataTypes';

const placeholdersMap = {
  [RNA_VALUES[RNA_TYPES.codingRNA]]: 'Search multiple gene symbols: HOMER2, SHOX2',
  [RNA_VALUES[RNA_TYPES.lncRNA]]: 'Search multiple gene symbols:A2ML1-AS2, ABCA9-AS1',
  [RNA_VALUES[RNA_TYPES.circRNA]]: 'Search related multiple gene symbols: SLC35A3, UBE4B',
  [RNA_VALUES[RNA_TYPES.miRNA]]: 'Search multiple gene symbols (miRBase v22 ID):hsa-miR-100-5p, hsa-let-7a-5p',
  [RNA_VALUES[RNA_TYPES.piRNA]]: 'Search multiple gene symbols (piRNABank ID): hsa_piR_000168, hsa_piR_000074',
  [RNA_VALUES[RNA_TYPES.tRFRNA]]: 'Search multiple gene symbols (MINTbase ID): tRF-16-026ZEDD, tRF-16-0RSSX7D',
};

export default {
  // name is required for keep-alive feature
  name: 'explore',
  components: {
    Heatmap,
  },
  data() {
    return {
      dataType: DATA_VALUES[DATA_TYPES.expression],
      rnaType: RNA_VALUES[RNA_TYPES.codingRNA],
      valid: true,
      geneSets: Object.keys(GENE_LISTS),
      selectedGeneSet: '',
      geneList: '',
      geneListRules: [
        val => !!val || 'Gene name is required',
      ],
      searchBtnLoading: false,
    };
  },
  computed: {
    rnaTypes() {
      const ret = [];
      const RNA_TEXTS = {
        [RNA_TYPES.codingRNA]: 'Protein coding RNA',
        [RNA_TYPES.lncRNA]: 'lncRNA',
        [RNA_TYPES.circRNA]: 'circRNA',
        [RNA_TYPES.miRNA]: 'miRNA',
        [RNA_TYPES.piRNA]: 'piRNA',
        [RNA_TYPES.tRFRNA]: 'tRFRNA',
      };
      Object.getOwnPropertySymbols(RNA_VALUES).forEach((rnaType) => {
        ret.push({
          value: RNA_VALUES[rnaType],
          text: RNA_TEXTS[rnaType],
        });
      });
      return ret;
    },
    dataTypes() {
      const ret = [];
      const DATA_TEXTS = {
        [DATA_TYPES.expression]: 'Expression Abundance',
        [DATA_TYPES.diffExpression]: 'Differential Expression',
      };
      Object.getOwnPropertySymbols(DATA_VALUES).forEach((dataType) => {
        ret.push({
          value: DATA_VALUES[dataType],
          text: DATA_TEXTS[dataType],
        });
      });
      return ret;
    },
    searchGenesPlaceholder() {
      return placeholdersMap[this.rnaType];
    },
  },
  // created() {
  //   this.checkDataState();
  // },
  methods: {
    // checkDataState() {
    //   const rnaType = getSession(RNA_TYPE_KEY);
    //   const dataType = getSession(DATA_TYPE_KEY);
    //   if (rnaType) this.rnaType = rnaType;
    //   if (dataType) this.dataType = dataType;
    // },
    select() {
      const genes = GENE_LISTS[this.selectedGeneSet];
      this.geneList = genes ? genes.join(',') : '';
    },
    normalizeInputGenes(geneList) {
      const genes = [];
      geneList.split(',').forEach((gene) => {
        const geneTrimmed = gene.trim();
        if (geneTrimmed) genes.push(geneTrimmed);
      });
      return genes.join('|');
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$once('search', () => {
          this.searchBtnLoading = true;
        });
        this.$once('xhr', () => {
          this.searchBtnLoading = false;
        });
        let targetIdx;
        if (this.rnaType === RNA_VALUES[RNA_TYPES.circRNA]) {
          // circRNA will still search gene symbol (2nd column) instead of gene id
          targetIdx = 1;
        } else { // others will search 1st column (whatever gene symbol or gene id)
          targetIdx = 0;
        }
        let { geneList } = this;
        if (geneList) {
          geneList = this.normalizeInputGenes(geneList);
          const regExSearch = `^(${geneList})$$`;
          this.dtApi.column(targetIdx).search(regExSearch, true, false).draw();
        } else {
          this.dtApi.column(targetIdx).search('').draw();
        }
      }
    },
    reset() {
      this.geneList = '';
      this.selectedGeneSet = '';
    },
    // checkGeneSetState() {
    //   const state = this.dtApi.state.loaded();
    //   if (state) {
    //     const stateGeneSet = state.geneSet;
    //     if (stateGeneSet) {
    //       const { geneList } = stateGeneSet;
    //       if (geneList) {
    //         this.geneList = geneList;
    //       }
    //     }
    //   }
    // },
    saveGeneSetState(data) {
      if (typeof data.geneSet === 'undefined') {
        // eslint-disable-next-line no-param-reassign
        data.geneSet = {};
      }
      // eslint-disable-next-line no-param-reassign
      data.geneSet.geneList = this.geneList;
    },
    initHandler() {
      this.dtApi = this.$refs.heatmap.getDTApi();
      // this.checkGeneSetState();
    },
    stateSaveParamsHandler(e, settings, data) {
      this.saveGeneSetState(data);
    },
    searchHandler(...args) {
      this.$emit('search', ...args);
    },
    xhrHandler(...args) {
      this.$emit('xhr', ...args);
    },
    saveRNAType(value) {
      setSession(RNA_TYPE_KEY, value);
    },
    saveDataType(value) {
      setSession(DATA_TYPE_KEY, value);
    },
  },
  watch: {
    rnaType() {
      this.reset();
    },
    dataType() {
      this.reset();
    },
  },
};
</script>

<style>
.v-label {
  margin-bottom: 0;
}
</style>
